module.exports = __webpack_public_path__ + "img/openseries.1cb1a46d.png";